import { createInertiaApp } from '@inertiajs/vue3'
import { createPinia } from 'pinia'
import axios from 'axios'
import { axiosAdapter, http } from '@inertiajs/core'
import AppIcon from '~conciergeUiCommons/components/AppIcon.vue'
import Popper from 'vue3-popper'
import '~conciergeUiCommons/libs/fontawesome.js'
import { i18nVue } from 'laravel-vue-i18n'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { domPurifyOptions } from '~conciergeUiCommons/libs/dompurify'
import { configureInertiaSentry, inertiaRoutingInstrumentation } from '~conciergeUiCommons/inertia-sentry';
import { initAnalytics } from '~conciergeUiCommons/inertia-analytics';

axios.interceptors.request.use((config) => {
    const lang = document?.documentElement?.lang;
    if (lang) {
        config.headers['Accept-Content-Language'] = lang;
        config.headers['Accept-Language'] = lang;
    }
    config.headers['Original-Source'] = localStorage.getItem('__user_original_source');

    return config;
});

const pinia = createPinia()
pinia.use(({ store }) => {
    store.service = 'conciergeEvent'
    // make sure your bundler handles this. webpack and vite should do it by default
    if (process.env.NODE_ENV === 'development') {
        store._customProperties.add('service')
    }
})

createInertiaApp({
    pages: './ConciergeEvent',
    http: axiosAdapter(axios),
    withApp(app, { page }) {
        const captchaKey = page.props.recaptcha_site_key;
        configureInertiaSentry(app, inertiaRoutingInstrumentation);
        app
            .component('Popper', Popper)
            .component('AppIcon', AppIcon)
            .use(pinia)
            .use(i18nVue, {
                resolve: lang => page.props.languages[lang],
                fallbackLang: document.documentElement.lang === 'en' ? 'fr' : 'en',
                fallbackMissingTranslations: true
            })
            .use(VueReCaptcha, { siteKey: captchaKey })
            .use(VueDOMPurifyHTML, domPurifyOptions)


        app.config.globalProperties.$route = route
    }
})

initAnalytics('u5ly4ufumb', 'GTM-WFNNJ73V')
